import * as React from "react";
import { Spin } from "antd";
import "./styles.scss";
import url from "../../url.json";
import axios from "axios";
import clsx from "clsx";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import headers from "../../config/headers.js";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { tokenReducer } from "../../Redux/Reducers/Token/TokenReducer";
import OneIdLogo from "./OneIdLogo";

import { PASSWORD_RULES, generatePassword } from "../../config/password";
import PasswordMeter from "../PasswordMeter/PasswordMeter";

const EyeIcon = ({ open }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    {open ? "" : <path d="M3 3l18 18" />}
  </svg>
);

function Friststep({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const dispatch = useDispatch();
  const [currenCountry, setcurrentCountry] = useState(1);
  const [country, setCountry] = useState();
  const [redirectUrl, setRedirectUrl] = useState([]);
  const [error, setError] = useState();
  const [sending, setSending] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ username: "", email: "", password: "", confirm: "" });

  useEffect(() => {
    axios.get(url.url + "/country", { headers: headers() }).then((res) => {
      setCountry(res.data);
    });
  }, []);
  useEffect(() => {
    fetch(url.url + "/auth/geturl")
      .then((res) => res.json())
      .then((data) => {
        if (data.url) setRedirectUrl(data.url);
      });
  }, []);

  const setField = (name) => (e) => {
    const value = e.target.value;
    setForm((f) => ({ ...f, [name]: value }));
    // foydalanuvchi maydonni tuzatayotganda eski xato xabari yo'qolsin
    if (error?.[name] || (name === "confirm" && error?.password_confirmation)) {
      setError((err) => ({ ...err, [name]: undefined, password_confirmation: name === "confirm" ? undefined : err?.password_confirmation }));
    }
  };

  const handleGenerate = () => {
    const pwd = generatePassword();
    setForm((f) => ({ ...f, password: pwd, confirm: pwd }));
    setShowPassword(true);
    setError((err) => ({ ...err, password: undefined, password_confirmation: undefined }));
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(pwd).then(
        () => toast.success(t("pw_generated_copied")),
        () => toast.info(t("pw_generated"))
      );
    } else {
      toast.info(t("pw_generated"));
    }
  };

  // withoutEri: O'zbekiston rezidenti ERI'siz — tashkilot ma'lumotlari qo'lda kiritiladi va moderator tasdiqlaydi
  const handleChange = (withoutEri = false) => {
    if (sending) return;
    const clientErrors = {};
    if (!form.username.trim()) clientErrors.username = [t("field_required")];
    if (!form.email.trim()) clientErrors.email = [t("field_required")];
    if (!form.password) clientErrors.password = [t("field_required")];
    else if (!PASSWORD_RULES.every((r) => r.test(form.password)) || /\s/.test(form.password))
      clientErrors.password = [t("pw_rules_error")];
    if (form.password && form.password !== form.confirm)
      clientErrors.password_confirmation = [t("pw_mismatch")];
    if (Object.keys(clientErrors).length) {
      setError(clientErrors);
      return;
    }

    const data = {
      name: "Bek",
      username: form.username.trim(),
      email: form.email.trim(),
      password: form.password,
      password_confirmation: form.confirm,
      country_id: currenCountry,
    };

    setSending(true);
    axios
      .post(url.url + "/register2", data, { headers: headers() })
      .then((res) => {
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          dispatch(tokenReducer(res.data.token));
          if (res.data.link && !withoutEri) {
            window.location.href = res.data.link;
          } else window.location.href = "/register/last-step";
        }
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status == 404) window.location = "/404";
        else if (status == 405) toast.error(err.response.data.error);
        else if (status == 429) toast.error(t("too many requests"));
        else if (!err.response) toast.error(t("Something went wrong"));
        setError(err.response?.data?.errors);
      })
      .finally(() => setSending(false));
  };

  const msg = (v) => (Array.isArray(v) ? v[0] : v);

  return (
    <Spin spinning={!country}>
      <form
        className="ln-signup"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleChange();
        }}
      >
        <div className="ln-field ln-signup__full">
          <label htmlFor="examplecountry">{t("Country")}</label>
          <select
            id="examplecountry"
            className="ln-select"
            value={currenCountry}
            onChange={(e) => setcurrentCountry(e.target.value)}
          >
            {(country?.data || []).map((res) => (
              <option key={res.id} value={res.id}>
                {res.name}
              </option>
            ))}
          </select>
        </div>

        <div className={clsx("ln-field", error?.username && "has-error")}>
          <label htmlFor="exampleUsername">{t("username1")}</label>
          <input
            id="exampleUsername"
            name="username"
            autoComplete="username"
            placeholder={t("Username enter")}
            value={form.username}
            onChange={setField("username")}
          />
          {error?.username ? <i>{msg(error.username)}</i> : ""}
        </div>

        <div className={clsx("ln-field", error?.email && "has-error")}>
          <label htmlFor="exampleEmail">{t("Email")}</label>
          <input
            id="exampleEmail"
            name="email"
            type="email"
            autoComplete="email"
            placeholder={t("email enter")}
            value={form.email}
            onChange={setField("email")}
          />
          {error?.email ? <i>{msg(error.email)}</i> : ""}
        </div>

        <div className={clsx("ln-field", error?.password && "has-error")}>
          <div className="ln-signup__label-row">
            <label htmlFor="examplePassword">{t("Password")}</label>
            <button type="button" className="ln-signup__gen" onClick={handleGenerate}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7L21 8" /><path d="M21 3v5h-5" /></svg>
              {t("pw_generate")}
            </button>
          </div>
          <div className="ln-signup__pw">
            <input
              id="examplePassword"
              name="password"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              placeholder={t("Password entry")}
              value={form.password}
              onChange={setField("password")}
            />
            <button
              type="button"
              className="ln-signup__eye"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={t(showPassword ? "pw_hide" : "pw_show")}
              title={t(showPassword ? "pw_hide" : "pw_show")}
            >
              <EyeIcon open={showPassword} />
            </button>
          </div>
          {error?.password ? <i>{msg(error.password)}</i> : ""}
        </div>

        <div className={clsx("ln-field", error?.password_confirmation && "has-error")}>
          <label htmlFor="exampleconPassword">{t("Password confirmation")}</label>
          <div className="ln-signup__pw">
            <input
              id="exampleconPassword"
              name="conpassword"
              type={showPassword ? "text" : "password"}
              autoComplete="new-password"
              placeholder={t("Password confirmation entry")}
              value={form.confirm}
              onChange={setField("confirm")}
            />
            {form.confirm && form.confirm === form.password ? (
              <span className="ln-signup__match" title={t("pw_match")}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
              </span>
            ) : (
              ""
            )}
          </div>
          {error?.password_confirmation ? <i>{msg(error.password_confirmation)}</i> : ""}
        </div>

        <div className="ln-signup__full">
          <PasswordMeter value={form.password} />
        </div>

        <div className="ln-signup__full ln-signup__actions">
          <button className="btnn" type="submit" disabled={sending}>
            {sending ? t("sending") : currenCountry == 1 ? t("Registration through ERI") : t("Next")}
          </button>
          {currenCountry == 1 ? (
            <div className="ln-signup__noeri">
              <button type="button" className="ln-btn ln-btn_outline" disabled={sending} onClick={() => handleChange(true)}>
                {t("ln_no_eri_btn")}
              </button>
              <small>{t("ln_no_eri_hint")}</small>
            </div>
          ) : (
            ""
          )}
          <p className="ln-signup__offer">
            {lan.value == "uz" ? (
              <>
                Ro’yxatan o’tish orqali siz <Link to="/offer">oferta</Link> shartlariga rozi ekaningizni bildirasiz
              </>
            ) : lan.value == "ru" ? (
              <>
                Регистрируясь, вы соглашаетесь с условиями <Link to="/offer">оферты</Link>
              </>
            ) : (
              <>
                By registering, you agree to the terms of the <Link to="/offer">offer</Link>
              </>
            )}
          </p>
        </div>

        <div className="ln-signup__full ln-login__or">
          <span>{t("ln_or_short")}</span>
        </div>

        <div className="ln-signup__full ln-signup__actions">
          <button
            className="btnn ln-signup__oneid"
            onClick={() => (window.location.href = redirectUrl)}
            type="button"
            aria-label="OneID"
          >
            <OneIdLogo />
          </button>
        </div>
      </form>
    </Spin>
  );
}
export default withTranslation()(Friststep);
